import { render, staticRenderFns } from "./TerminateRecord.vue?vue&type=template&id=cedec564&scoped=true"
import script from "./TerminateRecord.vue?vue&type=script&lang=js"
export * from "./TerminateRecord.vue?vue&type=script&lang=js"
import style0 from "./TerminateRecord.vue?vue&type=style&index=0&id=cedec564&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cedec564",
  null
  
)

export default component.exports